import './styles.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'jotai';
import InitScreen from './startloader';
//import { App_module } from './App_new';
import React, { Suspense } from 'react';
const App_module = React.lazy(() =>
  import('./App_new').then((m) => ({ default: m.App_module }))
);

import { store, worker_register_chunks_atom } from './atomstore';
import './design_interface.css';
import { ClerkProvider, SignedIn, SignedOut, RedirectToSignIn, useAuth } from "@clerk/clerk-react";
import SessionActivator from './SessionActivator';
console.log("🚀 [BOOT] Index.tsx gestartet");


store.set(
  worker_register_chunks_atom,
  new Worker(
    new URL("./services/worker_register_chunks.ts", import.meta.url),
    { type: "module" }
  )
);



// ✅ HIER EINFÜGEN (vor document.getElementById)
window.addEventListener("error", (e: any) => {
  console.error("[GLOBAL_ERROR]", e?.message, {
//    file: e?.filename,
    line: e?.lineno,
    col: e?.colno,
 //   stack: e?.error?.stack,
  });
});

window.addEventListener("unhandledrejection", (e: any) => {
  console.error("[UNHANDLED_REJECTION]", e?.reason?.message || e?.reason, {
//    stack: e?.reason?.stack,
    reason: e?.reason,
  });
});



console.log("[JOTAI] store.set patched in ROOT");

const rootElement = document.getElementById('app-root');
if (rootElement) {
  const root = createRoot(rootElement);
  const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;
root.render(
  <React.StrictMode>
<ClerkProvider
  publishableKey={clerkPubKey}
  signInUrl="https://login.sellermind.de/"
  afterSignInUrl="https://dealmaker.sellermind.de/"
  afterSignUpUrl="https://dealmaker.sellermind.de/"
>
      <SignedIn>
        <Provider store={store}>
      {/* Der Wrapper sitzt HIER, innerhalb von SignedIn */}
      <SessionActivator>
          <Suspense fallback={<InitScreen />}>
            <App_module />
          </Suspense>
      </SessionActivator>
        </Provider>
      </SignedIn>

      <SignedOut>
        <RedirectToSignIn redirectUrl="https://login.sellermind.de/" />
      </SignedOut>
    </ClerkProvider>
  </React.StrictMode>
);
}
